import {ReactElement} from "react";
import classNames from "classnames";

interface WalletTypeBadgeProps {
    walletType?: string;
    className?: string;
    iconOnly?: boolean;
}

/**
 * Badge component to display wallet type icon for NFTs
 * Shows which wallet the NFT is stored in (Thirdweb, WalletConnect, or Magic)
 * Used to help users identify which NFTs are easiest to transfer
 */
function WalletTypeBadge(props: WalletTypeBadgeProps): ReactElement | null {
    if (!props.walletType) {
        return null;
    }

    // Map wallet types to user-friendly display names and icons
    const getWalletInfo = (walletType: string): { label: string; iconPath: string; className: string } | null => {
        switch (walletType) {
            case "THIRDWEB":
                return {
                    label: "Devour",
                    iconPath: "/images/devour-wallet-icon.png",
                    className: "wallet-badge-thirdweb",
                };
            case "WALLET_CONNECT":
                return {
                    label: "WalletConnect",
                    iconPath: "/images/wallet-connect-icon.png",
                    className: "wallet-badge-wallet-connect",
                };
            case "MAGIC":
                return {
                    label: "Magic",
                    iconPath: "/images/magic-wallet-icon.webp",
                    className: "wallet-badge-magic",
                };
            default:
                return null;
        }
    };

    const walletInfo = getWalletInfo(props.walletType);

    if (!walletInfo) {
        return null;
    }

    if (props.iconOnly) {
        return (
            <img
                src={walletInfo.iconPath}
                alt={`${walletInfo.label} wallet`}
                title={`Stored in ${walletInfo.label} wallet`}
                className={classNames("wallet-type-badge-icon-only", walletInfo.className, props.className)}
            />
        );
    }

    return (
        <div
            className={classNames("wallet-type-badge", walletInfo.className, props.className)}
            title={`Stored in ${walletInfo.label} wallet`}
        >
            <img
                src={walletInfo.iconPath}
                alt={`${walletInfo.label} wallet icon`}
                className="wallet-type-badge__icon"
            />
            <span className="wallet-type-badge__label">{walletInfo.label}</span>
        </div>
    );
}

export default WalletTypeBadge;
